import classNames from 'classnames';
import React from 'react';
import iconCore from './assets/icon_core.webp';
import iconPro from './assets/icon_pro.webp';

interface MembershipSelectorProps {
  selectedTier: 'core' | 'pro';
  onTierChange: (tier: 'core' | 'pro') => void;
}

export const MembershipSelector = (props: MembershipSelectorProps) => {
  const { selectedTier, onTierChange } = props;
  const tierCoreSelected = selectedTier === 'core';
  const tierProSelected = selectedTier === 'pro';

  const onClick = (tier: 'core' | 'pro') => () => {
    onTierChange(tier);
  };

  return (
    <ul className="flex gap-3">
      <li
        className={classNames(
          'w-1/2 border rounded-2xl flex',
          tierCoreSelected && 'bg-gradient-to-b from-white/50 to-[#D9EEF5]',
          {
            'border-[#BDCAC5]': tierProSelected,
            'border-[#061622]': tierCoreSelected,
            outline: tierCoreSelected,
            'shadow-md': tierCoreSelected,
          }
        )}
      >
        <label className="p-4 flex flex-col gap-2 cursor-pointer relative">
          <div>
            <img src={iconCore} width={40} height={55} alt="Omnia Core" className="-mb-2 -ml-1" />
            <p className="font-termina text-[#061622] text-[13px] leading-tight font-bold">Core</p>
          </div>
          <p className="text-[#6B7172] text-[13px]">
            C-MAP® Contours, 5% Credit Back on Orders and More
          </p>
          <div className="mt-auto flex flex-col text-right">
            <span className="font-termina font-bold">$39/YR</span>
            <span className="text-[11px]">($3.25/month)</span>
          </div>
          <div className="rounded-full w-[18px] h-[18px] border-2 border-[#061622] p-0.5 flex items-center justify-center absolute top-4 right-4">
            {tierCoreSelected && <div className="rounded-full w-full h-full bg-[#061622]"></div>}
          </div>
          <input
            type="radio"
            name="pro_tier"
            value="core"
            onChange={onClick('core')}
            className="sr-only"
            defaultChecked={tierCoreSelected}
          />
        </label>
      </li>
      <li
        className={classNames(
          'w-1/2 border rounded-2xl flex',
          tierProSelected && 'bg-gradient-to-b from-white/50 to-[#E8DBAD]',
          {
            'border-[#BDCAC5]': tierCoreSelected,
            'border-[#061622]': tierProSelected,
            outline: tierProSelected,
            'shadow-md': tierProSelected,
          }
        )}
      >
        <label className="p-4 flex flex-col gap-2 cursor-pointer relative">
          <div>
            <img src={iconPro} width={40} height={55} alt="Omnia PRO" className="-mb-2 -ml-1" />
            <p className="font-termina text-[#061622] text-[13px] leading-tight font-bold">PRO</p>
          </div>
          <p className="text-[#6B7172] text-[13px]">
            Navionics® HD + C-MAP® Contours, 10% Credit Back on Orders and More
          </p>
          <div className="mt-auto flex flex-col text-right">
            <span className="font-termina font-bold">$59/YR</span>
            <span className="text-[11px]">($4.92/month)</span>
          </div>
          <div className="rounded-full w-[18px] h-[18px] border-2 border-[#061622] p-0.5 flex items-center justify-center absolute top-4 right-4">
            {tierProSelected && <div className="rounded-full w-full h-full bg-[#061622]"></div>}
          </div>
          <input
            type="radio"
            name="pro_tier"
            value="pro"
            onChange={onClick('pro')}
            className="sr-only"
            defaultChecked={tierProSelected}
          />
        </label>
      </li>
    </ul>
  );
};
